import { FormControl, IconButton, MenuItem, Select } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import { TableCellParams, TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { NoteModals } from '../../../../lib/NoteModals';
import { fetchInvestorDetails } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { INVETSOR_DETAILS_RESPONSE } from '../../../../redux-store/types/nct';
import { LIST_PROTFOLIO_PAYLOAD } from '../../../../redux-store/types/portfolio';
import { CONSOLIDATION_FOLIOS } from '../../../../utils/constants';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
import {
    fundsByLienFlag,
    getInvestorFunds,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import NoFoliosFound from '../NoFoliosFound';
import { ConsolidateTableRowType } from './types';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
const { dashboard } = en;

export const _renderBank = ({ collapse, setCollapse }: TableCellParams) => {
    return (
        <>
            {/* <span>{row.bank[0]?.name}</span> */}
            <IconButton
                className="update-nominee-collapse-btn"
                aria-label="expand row"
                size="small"
                style={{ marginLeft: 0 }}
                onClick={(e) => {
                    e.stopPropagation();
                    setCollapse((open: boolean) => !open);
                }}
            >
                {!collapse ? (
                    <>
                        <span>View</span>
                        <KeyboardArrowDown />
                    </>
                ) : (
                    <>
                        <span>Hide</span>
                        <KeyboardArrowUp />
                    </>
                )}
            </IconButton>
        </>
    );
};

export const Columns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'FOLIO',
        // filterBy: true,
    },
    // {
    //     field: 'amcName',
    //     headerName: 'FUND',
    //     width: 250,
    // },
    {
        field: 'investorName',
        headerName: 'PRIMARY HOLDER',
        width: 200,
    },
    {
        field: 'investorPan',
        headerName: 'PAN',
        width: 100,
    },
    {
        field: 'modeOfHolding',
        headerName: 'MODE OF HOLDING',
        width: 100,
    },
    {
        field: 'bank',
        headerName: 'BANK NAME',
        valueGetter: ({ row }) => row.bank[0]?.name,
        width: 200,
    },
    {
        field: '',
        headerName: '',
        renderCell: _renderBank,
        width: 50,
    },
];

export const keys = [
    { label: '2nd Holder name', key: 'secondHolder' },
    { label: '3rd Holder name', key: 'thirdHolder' },
    { label: 'Tax Residency', key: 'taxStatusLabel' },
    { label: 'Bank A/C No', key: 'accountNo' },
    { label: ' IFSC', key: 'ifsc' },
    { label: '1st Nominee Name', key: 'firstNominee' },
    {
        label: '2nd Nominee Name',
        key: 'secondNominee',
    },
    {
        label: '3rd Nominee Name',
        key: 'thirdNominee',
    },
];

function ConsolidationFolios(props: any) {
    const [rowData, setRowdata] = useState<ConsolidateTableRowType[]>([]);
    const [consolidateFunds, setConsolidateFunds] = useState<INVETSOR_DETAILS_RESPONSE[]>([]);
    const {
        setSelectedRows: setTargetFunds,
        selectedRows: targetFunds,
        tableRows,
        tableColumns,
        ...filters
    } = useTableWithCollapse<ConsolidateTableRowType[]>({
        initialSelectionModal: [],
        rows: rowData,
        columns: Columns,
    });
    const [amcType, setAmcType] = useState<any>('NONE');
    const [show, setShow] = useState<boolean>(false);

    useEffect(() => {
        async function callApi() {
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan: props.pan,
                mobile: props.mobile,
                pekrn: props.pekrn,
                reqId: props.reqId,
            };
            try {
                const { body: investorDetails = {} } = await props.fetchInvestorDetails(payload);
                let { success: consolidationData = [] } = investorDetails;
                consolidationData.sort((firstEl: any, secondEl: any) => {
                    let amcName1 = firstEl.amcName.toUpperCase();
                    let amcName2 = secondEl.amcName.toUpperCase();
                    if (amcName1 < amcName2) {
                        return -1;
                    }
                    if (amcName1 > amcName2) {
                        return 1;
                    }

                    return 0;
                });
                const consolidationRowData = getInvestorFunds(consolidationData, [
                    portfoliosByTransactionResource,
                    fundsByLienFlag,
                ]);
                setRowdata(consolidationRowData);
                setConsolidateFunds(consolidationData);
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
        return () => {};
    }, []);

    const _onGotoSourceFolios = async () => {
        const [targetFund] = targetFunds;
        /**
         *  Target folio taxtStaus should match with consolidated fund Taxstatus
         * @param taxStatus
         */
        const matchTaxStatus = ({ taxStatus }: ConsolidateTableRowType) =>
            taxStatus === targetFund?.taxStatus;

        /**
         * Target folio PAN should match with consolidated fund  PAN when investor login with PAN
         * Target folio PEKRN should match with consolidated fund  PEKRN when investor login with PEKRN
         * Target folio second holder PAN should match with consolidated fund PAN when investor login with PAN
         * Target folio second holder PEKRN should match with consolidated fund PEKRN when investor login with PEKRN
         * Target folio third holder PAN should match with consolidated fund PAN when investor login with PAN
         * Target folio third holder PEKRN should match with consolidated fund PEKRN when investor login with PEKRN
         * @param investorPan
         * @param investorPekrn
         * @param secondHolderPan
         * @param secondHolderPekrn
         * @param thirdHolderPan
         * @param thirdHolderPekrn
         */
        const matchInvestor = ({
            investorPekrn,
            investorPan,
            secondHolderPan,
            secondHolderPekrn,
            thirdHolderPan,
            thirdHolderPekrn,
        }: ConsolidateTableRowType) =>
            props.pan
                ? investorPan === targetFund?.investorPan &&
                  secondHolderPan === targetFund?.secondHolderPan &&
                  thirdHolderPan === targetFund?.thirdHolderPan
                : investorPekrn === targetFund?.investorPekrn &&
                  secondHolderPekrn === targetFund?.secondHolderPekrn &&
                  thirdHolderPekrn === targetFund?.thirdHolderPekrn;

        /**
         * Target folio modeOfHolding should match with consolidated fund modeOfHolding
         * @param modeOfHolding
         */
        const matchModeOfholding = ({ modeOfHolding }: ConsolidateTableRowType) => {
            const targetModeOfHolding = targetFund?.modeOfHolding.toUpperCase();
            const modeOfHoldingToUpperCase = modeOfHolding.toUpperCase();
            const mohAnyoneorSurvivorSource =
                modeOfHoldingToUpperCase === 'ANYONE OR SURVIVOR' ||
                modeOfHoldingToUpperCase === 'ANYONE/SURVIVOR';
            const mohEitherorSurvivorSource =
                modeOfHoldingToUpperCase === 'EITHER OR SURVIVOR' ||
                modeOfHoldingToUpperCase === 'EITHER/SURVIVOR';
            const mohAnyoneorSurvivorTargetFund =
                targetModeOfHolding === 'ANYONE OR SURVIVOR' ||
                targetModeOfHolding === 'ANYONE/SURVIVOR';
            const mohEitherorSurvivorTargetFund =
                targetModeOfHolding === 'EITHER/SURVIVOR' ||
                targetModeOfHolding === 'EITHER OR SURVIVOR';
            return (
                (mohAnyoneorSurvivorSource && mohAnyoneorSurvivorTargetFund) ||
                (mohEitherorSurvivorSource && mohEitherorSurvivorTargetFund) ||
                modeOfHoldingToUpperCase === targetModeOfHolding
            );
        };

        const matchAmcType = ({ amcName }: ConsolidateTableRowType) => amcName === amcType;

        /**
         * Target folio Joint Holder PAN should match with consolidated fund  Joint Holders PAN when investor login with PAN
         * Target folio Joint Holder PEKRN should match with consolidated fund  Joint Holders PEKRN when investor login with PEKRN
         * @param secondHolderPan
         * @param secondHolderPekrn
         * @param thirdHolderPan
         * @param thirdHolderPekrn
         */
        const matchJointHolders = ({
            secondHolderPan,
            secondHolderPekrn,
            thirdHolderPekrn,
            thirdHolderPan,
        }: ConsolidateTableRowType) =>
            props.pan
                ? secondHolderPan === targetFund?.secondHolderPan &&
                  thirdHolderPan === targetFund?.thirdHolderPan
                : secondHolderPekrn === targetFund?.secondHolderPekrn &&
                  thirdHolderPekrn === targetFund?.thirdHolderPekrn;

        const { matched, unMatched } = rowData.reduce(
            (
                prev: {
                    matched: ConsolidateTableRowType[];
                    unMatched: ConsolidateTableRowType[];
                },
                fund: ConsolidateTableRowType,
            ) => {
                if (fund.id === targetFund?.id || fund?.amc !== targetFund?.amc) {
                    return prev;
                }
                const matched = [
                    matchTaxStatus,
                    matchJointHolders,
                    matchModeOfholding,
                    matchInvestor,
                ].every((func: Function) => func.call({}, fund));
                if (matched) {
                    prev = {
                        ...prev,
                        matched: [...prev.matched, fund],
                    };
                } else {
                    prev = {
                        ...prev,
                        unMatched: [...prev.unMatched, { ...fund, isDisabled: true }],
                    };
                }
                return prev;
            },
            {
                matched: [],
                unMatched: [],
            },
        );
        const routeStateParams = {
            amcType: amcType === 'NONE' ? targetFund?.amc : amcType,
            amc: targetFund?.amc,
            folio: targetFund?.folio,
            matched,
            unMatched,
        };
        props.history.push('consolidate-source-folios', routeStateParams);
    };

    const filteredFunds = useMemo(() => {
        return tableRows.filter((fund) => fund.amcName === amcType || amcType === 'NONE');
    }, [amcType, tableRows]);

    const _renderCollapse = ({ row }: { row: ConsolidateTableRowType }) => {
        const { nominees = [], bank } = row;
        const rowKeydData: any = {
            firstNominee: nominees[0]?.name,
            secindNominee: nominees[1] ? nominees[1]?.name : '',
            thirdNominee: nominees[2] ? nominees[2]?.name : '',
            ifsc: bank[0]?.ifsc,
            accountNo: bank[0]?.accountNo,
            ...row,
        };
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'space-between',
                    flexWrap: 'wrap',
                    flexDirection: 'row',
                    width: '100%',
                }}
            >
                {keys.map(({ label, key }, index) => (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '25%',
                            marginBottom: 15,
                            paddingRight: 15,
                        }}
                    >
                        <label>{label}</label>
                        <label>{rowKeydData[key] || ''}</label>
                    </div>
                ))}
            </div>
        );
    };

    const TableBody = useMemo(() => {
        return (
            <TableWithCollapse
                rows={filteredFunds}
                columns={tableColumns}
                selectedRows={targetFunds}
                setSelectedRows={setTargetFunds}
                renderCollapse={_renderCollapse}
                radioGroupsEnabled
                {...filters}
            />
        );
    }, [filteredFunds, Columns, targetFunds, filters]);

    const [callPanSeed, setCallPanSeed] = useState(false);

    const resetTrigger = () => {
        setCallPanSeed(false);
    }

    return (
        <div className="curved-bg">
            <PanSeedCheckNew
                foliosArray={targetFunds}
                callBackFn = {() => {
                    setShow(true);
                }}
                resetTrigger={resetTrigger}
                triggerCheck={callPanSeed}
                trxnType={NFT_TRXN_TYPE_MAP.consolidationOfFolios}
            />
            <ActionHeader header={dashboard.ConsolidationFolios.ConsolidationFoliosHeading} />
            <div className="curved-bg-content curved-bg-table-outer consolidated-folios-outer">
                <div className="curved-bg-content-table">
                    <h5> {dashboard.ConsolidationFolios.chooseMutualFund}</h5>
                    <FormControl variant="outlined">
                        <Select
                            onChange={({ target: { value } }) => setAmcType(value)}
                            labelId="portfolio-sortby-label"
                            id="portfolio-sortby"
                            value={amcType}
                        >
                            <MenuItem value="NONE">Select one</MenuItem>
                            {consolidateFunds.map((fund) => (
                                <MenuItem key={fund.amc} value={fund.amcName}>
                                    {fund.amcName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {amcType !== 'NONE' && (
                        <>
                            <h5>{dashboard.ConsolidationFolios.selectFolio}</h5>
                            <div className="curved-table-content">
                                {filteredFunds.length < 2 ? (
                                    <NoFoliosFound
                                        extraClass="consolidation-error"
                                        icon="error-red"
                                        info={
                                            !filteredFunds.length
                                                ? dashboard.ConsolidationFolios.EmptyFolioInfo
                                                : dashboard.ConsolidationFolios
                                                      .NoConsolidateFoliosInfo
                                        }
                                    />
                                ) : (
                                    TableBody
                                )}
                            </div>
                        </>
                    )}
                </div>
                {amcType !== 'NONE' && (
                    <>
                        <FaqLink section={CONSOLIDATION_FOLIOS} history={props.history} />
                        <div className="curved-bg-content-inner-bottom">
                            <div className="table-submit">
                                <SubmitButton
                                    disabled={!targetFunds?.length}
                                    onClick={() => setCallPanSeed(true)}
                                    className="customBtn"
                                    label={dashboard.ConsolidationFolios.buttonText}
                                />
                            </div>
                        </div>
                    </>
                )}
                <NoteModals
                    showModal={show}
                    heading={dashboard.noteModals.consolidation.heading}
                    info={dashboard.noteModals.consolidation.info}
                    // proceedBtn={dashboard.noteModals.otpModal.proceedText}
                    proceedBtn={'Okay'}
                    onProceed={_onGotoSourceFolios}
                />
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    fetchInvestorDetails,
})(ConsolidationFolios);
